$(function () {
	let lastTime = 0,
		vendors = ['ms', 'moz', 'webkit', 'o'];
	for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	}

	if (!window.requestAnimationFrame)
		window.requestAnimationFrame = function (callback) {
			let currTime = new Date().getTime(),
				timeToCall = Math.max(0, 16 - (currTime - lastTime)),
				id = window.setTimeout(function () {
						callback(currTime + timeToCall);
					},
					timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};

	if (!window.cancelAnimationFrame)
		window.cancelAnimationFrame = function (id) {
			clearTimeout(id);
		};
});

PJQ.helpers.photoHelpers = {
	easeOutQuart: function (currentTime, initialVal, changedVal, duration) {
		currentTime /= duration;
		currentTime--;
		return -changedVal * (currentTime * currentTime * currentTime * currentTime - 1) + initialVal;
	}
};

PJQ.views.photos.PhotoViewer = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Photo-Viewer'),
		elementId: 'iv-outer',
		zoomValue: 100,
		snapView: true,
		maxZoom: 500,
		refreshOnResize: true,
		canDownload: true,
		zoomOnMouseWheel: true,
		triggerRoute: false,
		onDelete: _.noop,
		shouldCreateCanvas: false,
		keyListeners: [
			{
				which: 27,
				keys: ['Escape', 'Esc'],
				callback: function () {
					this.destroy();
				}
			},
			{
				which: 37,
				callback: function () {
					this.previous();
				}
			},
			{
				which: 39,
				callback: function () {
					this.next();
				}
			},
			{
				which: 68,
				shiftKey: true,
				callback: function () {
					this.downloadFile();
					$(window).focus();
				}
			},
			{
				which: 82,
				shiftKey: true,
				callback: function () {
					this.destroy();
				}
			}
		]
	},
	events: {
		'click .iv-prev': 'previous',
		'click .iv-next': 'next',
		'click .iv-rotate-neg-90': 'rotateNeg90',
		'click .iv-rotate-90': 'rotate90'
	},
	beforeFirstRender: function () {
		let viewport = document.querySelector('meta[name="viewport"]');
		if (viewport) {
			viewport.content = "width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0";
		}

		let $body = $('body');

		//First set the element to the outer container so the photo gallery view renders inside of it
		this.setElement($('#' + this.options.elementId));

		if (_.size(this.$el) === 0) {
			let $outer = $('<div>', {
				id: this.options.elementId
			});
			$body.append($outer);
			this.setElement($outer);
		}

		$body.css('overflow', 'hidden');

		this.ZOOM_CONSTANT = 40;
		this.MOUSE_WHEEL_COUNT = 5;
		this.zoomValue = 100;

		this.options.previousRoute = PJQ.app.router.getCurrentRoute();
		if (this.options.route) {
			PJQ.app.router.navigate(this.options.route);
		}
	},
	renderData: function () {
		return {
			model: this.model,
			options: this.options
		};
	},
	setContainerDimensions: function () {
		let $window = $(window);
		this.$el.css({
			"max-width": $window.width(),
			"max-height": $window.height()
		});
	},
	afterRender: function () {
		let $contain = this.$('.iv-container');
		this.setElement($contain);
		this.setContainerDimensions();

		if (this.options.canDownload) {
			this.$('.iv-download').removeClass('hidden');
		}

		if (this.options.canDelete) {
			this.$('.iv-delete').removeClass('hidden');
		}

		if (this.$el.css('position') === 'static') {
			this.$el.css('position', 'relative');
		}

		this.snapView = this.$('.iv-snap-view');
		this.snapImageWrap = this.$('.iv-snap-image-wrap');
		this.imageView = this.$('.iv-image-view');
		this.imageWrap = this.$('.iv-image-wrap');
		this.snapHandle = this.$('.iv-snap-handle');
		this.zoomHandle = this.$('.iv-zoom-handle');
		this.createdOnDate = this.$('.photo-created-date');
		this._viewerId = 'iv_' + _.uniqueId();

		this.keydownListener = _.bind(function (e) {
			if ($(e.target).is(':input')) {
				return;
			}

			e = e || window.event;
			let listener = _.find(this.options.keyListeners, function (listener) {
				return (_.indexOf(listener.keys, e.key) !== -1 || listener.which === e.which) && (!listener.shiftKey || e.shiftKey);
			});
			if (listener != null && typeof listener.callback === 'function') {
				_.bind(listener.callback, this)();
			}
		}, this);

		let eventSuffix = '.' + this._viewerId;
		$(document).on('keydown' + eventSuffix, this.keydownListener);

		this.prevButton = this.$('.iv-prev');
		this.nextButton = this.$('.iv-next');

		this.init();

		this.initViewer();
	},
	downloadFile: function () {
		this.model.download();
	},
	initViewer: function () {
		if (this.model != null) {
			this.initPaging();
			this.renderPage();
		}
		else if (this.options.image) {
			this.show(this.options.image);
		}
	},
	initPaging: function () {
		this.pagingModels = _.sortBy(_.filter(this.model.collection.models, function (model) {
			return typeof model.isImage === 'function' && model.isImage();
		}), function (model) {
			return model.id ? -model.id : 0;
		});

		this.pageIndex = null;
		_.each(this.pagingModels, function (model, index) {
			if (model.cid === this.model.cid) {
				this.pageIndex = index;
			}
		}, this);

		if (this.pageIndex != null) {
			this.$('.iv-paging').removeClass('hidden');
			this.pagingDisplay = this.$('.iv-paging-display');
			this.renderPaging();
		}
	},
	renderPaging: function () {
		let modelCount = _.size(this.pagingModels);
		this.pagingDisplay.html((this.pageIndex + 1).toString() + ' of ' + modelCount.toString());
		if (this.pageIndex === 0) {
			this.prevButton.addClass('disabled');
		}
		else {
			this.prevButton.removeClass('disabled');
		}

		if ((this.pageIndex + 1) === modelCount) {
			this.nextButton.addClass('disabled');
		}
		else {
			this.nextButton.removeClass('disabled');
		}
	},
	renderPage: function () {
		this.model = this.pagingModels[this.pageIndex];
		let url = this.model.get('url');
		if (_.size(url) > 0) {
			this.show(this.model.get('url'));
		}
		else if (this.model.file != null && this.model.file.dataURL != null) {
			this.show(this.model.file.dataURL);
		}
	},
	previous: function () {
		if (this.pageIndex > 0) {
			--this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	next: function () {
		if ((this.pageIndex + 1) < _.size(this.pagingModels)) {
			++this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	rotate: function (degrees) {
		//this code is only needed if we want to implement saved rotation and not just temporary viewing rotation
		// new PJQ.ajax.Request({
		// 	endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
		// 		{
		// 			endpoint: 'files',
		// 			value: this.model.get('guid')
		// 		},
		// 		{
		// 			endpoint: 'rotate'
		// 		}
		// 	], [
		// 		{
		// 			parameter: 'degrees',
		// 			value: degrees
		// 		}
		// 	])
		// }).put().done(_.bind(function () {
		// 	this.renderPage();
		// }, this));
		let rotation = this.model.get('rotation') != null ? this.model.get('rotation') : 0;
		if (rotation === 0 && degrees < 0) {
			rotation = 360;
		}
		else if (rotation === 360 && degrees > 0) {
			rotation = 0;
		}
		this.model.set('rotation', (rotation + degrees) % 360);
		this.renderPage();
	},
	rotate90: function () {
		this.rotate(90);
	},
	rotateNeg90: function () {
		this.rotate(-90)
	},
	canDrag: function () {
		return true;
	},
	canZoom: function () {
		return true;
	},
	shouldCreateCanvas: function () {
		return this.options.shouldCreateCanvas === true;
	},
	init: function () {
		let viewer = this,
			options = this.options,
			eventSuffix = '.' + viewer._viewerId,
			snapHandle = this.snapHandle,
			snapImgWrap = this.snapImageWrap,
			imageWrap = this.imageWrap,
			snapSlider = new PJQ.views.photos.Slider(snapImgWrap, {
				sliderId: viewer._viewerId,
				onStart: function () {
					if (!viewer.loaded) {
						return false;
					}

					this.curHandleTop = parseFloat(snapHandle.css('top'));
					this.curHandleLeft = parseFloat(snapHandle.css('left'));
					this.handleWidth = parseFloat(snapHandle.width());
					this.handleHeight = parseFloat(snapHandle.height());

					this.width = snapImgWrap.width();
					this.height = snapImgWrap.height();

					//stop momentum on image
					clearInterval(imageSlider.slideMomentumCheck);
					cancelAnimationFrame(imageSlider.sliderMomentumFrame);
				},
				onMove: function (e, position) {
					let maxLeft = Math.max(this.width - this.handleWidth, this.curHandleLeft),
						maxTop = Math.max(this.height - this.handleHeight, this.curHandleTop),
						minLeft = Math.min(0, this.curHandleLeft),
						minTop = Math.min(0, this.curHandleTop),
						left = PJQ.helpers.mathHelpers.clamp(this.curHandleLeft + position.dx, minLeft, maxLeft),
						top = PJQ.helpers.mathHelpers.clamp(this.curHandleTop + position.dy, minTop, maxTop),
						imgLeft = viewer.imgWidth < viewer.containerDim.w ? (viewer.containerDim.w - viewer.imgWidth) / 2 : -left * viewer.imgWidth / this.width,
						imgTop = viewer.imgHeight < viewer.containerDim.h ? (viewer.containerDim.h - viewer.imgHeight) / 2 : -top * viewer.imgHeight / this.height;

					snapHandle.css({
						top: top + 'px',
						left: left + 'px'
					});

					viewer.currentImg.css({
						left: imgLeft,
						top: imgTop
					});
					if (viewer.shouldCreateCanvas()) {
						viewer.$canvas.css({
							left: imgLeft,
							top: imgTop
						});

						viewer.$activeCanvas.css({
							left: imgLeft,
							top: imgTop
						});

						viewer.$tooltips.css({
							left: imgLeft,
							top: imgTop
						});

						let cOff = viewer.$canvas.offset();
						viewer.canvas.x = cOff.left;
						viewer.canvas.y = cOff.top;
					}
				}
			}).init();

		/*Add slide interaction to image*/
		let imageSlider = viewer._imageSlider = new PJQ.views.photos.Slider(imageWrap, {
			viewer: viewer,
			sliderId: viewer._viewerId,
			onStart: function (e, position) {
				if (!viewer.loaded) {
					return false;
				}
				if (viewer.zooming) {
					return;
				}
				let self = this;
				snapSlider.onStart();

				self.positions = [position, position];

				self.startPosition = position;

				//clear all animation frame and interval
				viewer._clearFrames();

				self.slideMomentumCheck = setInterval(function () {
					if (!self.currentPos) {
						return;
					}

					self.positions.shift();
					self.positions.push({
						x: self.currentPos.mx,
						y: self.currentPos.my
					})
				}, 30);
			},
			onMove: function (e, position) {
				if (viewer.zooming) {
					return;
				}
				this.currentPos = position;

				snapSlider.onMove(e, {
					dx: -position.dx * snapSlider.width / viewer.imgWidth,
					dy: -position.dy * snapSlider.height / viewer.imgHeight
				});
			},
			onEnd: function () {
				if (viewer.zooming) {
					return;
				}
				let self = this,
					xDiff = this.positions[1].x - this.positions[0].x,
					yDiff = this.positions[1].y - this.positions[0].y,
					positionX = 0,
					positionY = 0,
					step = 1;

				if (Math.abs(xDiff) > 30 || Math.abs(yDiff) > 30) {
					positionX = self.currentPos.dx;
					positionY = self.currentPos.dy;

					function momentum() {
						if (step <= 60) {
							self.sliderMomentumFrame = requestAnimationFrame(momentum);
						}

						positionX = positionX + PJQ.helpers.photoHelpers.easeOutQuart(step, xDiff / 3, -xDiff / 3, 60);
						positionY = positionY + PJQ.helpers.photoHelpers.easeOutQuart(step, yDiff / 3, -yDiff / 3, 60);

						snapSlider.onMove(null, {
							dx: -((positionX) * snapSlider.width / viewer.imgWidth),
							dy: -((positionY) * snapSlider.height / viewer.imgHeight)
						});
						step++;
					}

					momentum();
				}
			}
		}).init();

		/*Add zoom iteration in mouse wheel*/
		let changedDelta = 0,
			self = this;
		imageWrap.on("mousewheel" + eventSuffix + " DOMMouseScroll" + eventSuffix, function (e) {
			if (!viewer.loaded || !options.zoomOnMouseWheel || !self.canZoom()) {
				return;
			}

			//clear all animation frame and interval
			viewer._clearFrames();

			// cross-browser wheel delta
			let delta = Math.max(-1, Math.min(1, (e.originalEvent.wheelDelta || -e.originalEvent.detail))),
				zoomValue = viewer.zoomValue * (100 + delta * viewer.ZOOM_CONSTANT) / 100;
			if (!(zoomValue >= 100 && zoomValue <= options.maxZoom)) {
				changedDelta += Math.abs(delta);
			}
			else {
				changedDelta = 0;
			}

			if (changedDelta > viewer.MOUSE_WHEEL_COUNT) {
				return;
			}

			e.preventDefault();

			let contOffset = self.$el.offset(),
				x = (e.pageX || e.originalEvent.pageX) - contOffset.left,
				y = (e.pageY || e.originalEvent.pageY) - contOffset.top;


			viewer.zoom(zoomValue, {
				x: x,
				y: y
			});

			//show the snap viewer
			showSnapView();
		});


		//apply pinch and zoom feature
		imageWrap.on('touchstart' + eventSuffix, function (eStart) {
			if (!self.canDrag() || !viewer.loaded) {
				return;
			}

			let touch0 = eStart.originalEvent.touches[0],
				touch1 = eStart.originalEvent.touches[1];
			if (!(touch0 && touch1)) {
				return;
			}

			viewer.zooming = true;

			let contOffset = self.$el.offset(),
				startDist = Math.sqrt(Math.pow(touch1.pageX - touch0.pageX, 2) + Math.pow(touch1.pageY - touch0.pageY, 2)),
				startZoom = viewer.zoomValue,
				center = {
					x: ((touch1.pageX + touch0.pageX) / 2) - contOffset.left,
					y: ((touch1.pageY + touch0.pageY) / 2) - contOffset.top
				},
				$document = $(document),
				moveListener = function (eMove) {
					eMove.preventDefault();

					let touch0 = eMove.originalEvent.touches[0],
						touch1 = eMove.originalEvent.touches[1],
						newDist = Math.sqrt(Math.pow(touch1.pageX - touch0.pageX, 2) + Math.pow(touch1.pageY - touch0.pageY, 2)),
						zoomValue = startZoom + (newDist - startDist) / 2;

					viewer.zoom(zoomValue, center);
				},
				endListener = function () {
					$document.off('touchmove', moveListener);
					$document.off('touchend', endListener);
					viewer.zooming = false;
				};

			$document.on('touchmove', moveListener);
			$document.on('touchend', endListener);
		});


		//handle double tap for zoom in and zoom out
		let touchtime = 0,
			point;
		imageWrap.on('click' + eventSuffix, function (e) {
			if (!self.canDrag()) {
				return;
			}

			if (touchtime === 0) {
				touchtime = Date.now();
				point = {
					x: e.pageX,
					y: e.pageY
				};
			}
			else {
				if ((Date.now() - touchtime) < 500 && Math.abs(e.pageX - point.x) < 50 && Math.abs(e.pageY - point.y) < 50) {
					if (viewer.zoomValue === options.zoomValue) {
						viewer.zoom(200)
					}
					else {
						viewer.resetZoom()
					}
					touchtime = 0;
				}
				else {
					touchtime = 0;
				}
			}
		});

		//zoom in zoom out using zoom handle
		let slider = viewer.snapView.find('.iv-zoom-slider');
		new PJQ.views.photos.Slider(slider, {
			viewer: viewer,
			sliderId: viewer._viewerId,
			onStart: function (eStart) {
				if (!viewer.loaded) {
					return false;
				}

				this.leftOffset = slider.offset().left;
				this.handleWidth = viewer.zoomHandle.width();
				this.onMove(eStart);
			},
			onMove: function (e) {
				let newLeft = (e.pageX || e.originalEvent.touches[0].pageX) - this.leftOffset - this.handleWidth / 2;

				newLeft = Math.max(0, newLeft);
				newLeft = Math.min(viewer._zoomSliderLength, newLeft);

				let zoomValue = 100 + (options.maxZoom - 100) * newLeft / viewer._zoomSliderLength;
				viewer.zoom(zoomValue);
			}
		}).init();

		//display snapView on interaction
		let snapViewTimeout,
			snapViewVisible;

		function showSnapView(noTimeout) {
			if (!options.snapView) {
				return;
			}

			if (snapViewVisible || viewer.zoomValue <= 100 || !viewer.loaded) {
				return;
			}
			clearTimeout(snapViewTimeout);
			snapViewVisible = true;
			viewer.snapView.css('opacity', 1);
			if (!noTimeout) {
				snapViewTimeout = setTimeout(function () {
					viewer.snapView.css('opacity', 0);
					snapViewVisible = false;
				}, 4000);
			}
		}

		imageWrap.on('touchmove' + eventSuffix + ' mousemove' + eventSuffix, function () {
			showSnapView();
		});

		let snapEventsCallback = {};
		snapEventsCallback['mouseenter' + eventSuffix + ' touchstart' + eventSuffix] = function () {
			snapViewVisible = false;
			showSnapView(true);
		};

		snapEventsCallback['mouseleave' + eventSuffix + ' touchend' + eventSuffix] = function () {
			snapViewVisible = false;
			showSnapView();
		};

		viewer.snapView.on(snapEventsCallback);

		//calculate elements size on window resize
		if (options.refreshOnResize) {
			$(window).on('resize' + eventSuffix, function () {
				viewer.refresh()
			});
		}

		//prevent scrolling the backside if container if fixed positioned
		this.imageView.on('touchmove' + eventSuffix + ' mousewheel' + eventSuffix + ' DOMMouseScroll' + eventSuffix, function (e) {
			e.preventDefault();
		});

		//assign event on close button
		this.$el.find('.iv-close').on('click' + eventSuffix, function () {
			viewer.destroy();
		});

		//assign event on delete button
		this.$el.find('.iv-delete').on('click' + eventSuffix, function () {
			viewer.delete();
		});

		//assign event on delete button
		this.$el.find('.iv-download').on('click' + eventSuffix, function (e) {
			viewer.download(e);
		});
	},
	zoom: function (perc, point) {
		perc = Math.round(Math.max(100, perc));
		perc = Math.min(this.options.maxZoom, perc);

		point = point || {
			x: this.containerDim.w / 2,
			y: this.containerDim.h / 2
		};

		this.lastZoomPoint = point;

		let maxZoom = this.options.maxZoom,
			curPerc = this.zoomValue,
			curImg = this.currentImg,
			curLeft = parseFloat(curImg.css('left')),
			curTop = parseFloat(curImg.css('top')),
			step = 0;

		this._clearFrames();

		//calculate base top,left,bottom,right
		let containerDim = this.containerDim,
			imageDim = this.imageDim,
			baseLeft = (containerDim.w - imageDim.w) / 2,
			baseTop = (containerDim.h - imageDim.h) / 2,
			baseRight = containerDim.w - baseLeft,
			baseBottom = containerDim.h - baseTop;
		let zoom = _.bind(function () {
			step++;

			if (step < 5) {
				this._zoomFrame = requestAnimationFrame(zoom);
			}

			let tickZoom = PJQ.helpers.photoHelpers.easeOutQuart(step, curPerc, perc - curPerc, 5),
				ratio = tickZoom / curPerc,
				imgWidth = this.imageDim.w * tickZoom / 100,
				imgHeight = this.imageDim.h * tickZoom / 100,
				newLeft = -((point.x - curLeft) * ratio - point.x),
				newTop = -((point.y - curTop) * ratio - point.y);

			//fix for left and top
			if(this.prevItemInfo && step === 5){
				let wIncrease = (this.prevItemInfo.canvas.width / this.canvas.width) * 100,
					hIncrease = (this.prevItemInfo.canvas.height / this.canvas.height) * 100

				if(wIncrease !== 100){
					newLeft = (this.prevItemInfo.position.left / wIncrease) * 100
				}
				else{
					newLeft = this.prevItemInfo.position.left
				}
				if(hIncrease !== 100){
					newTop = (this.prevItemInfo.position.top / hIncrease) * 100
				}
				else{
					newTop = this.prevItemInfo.position.top
				}
				this.prevItemInfo = null;
			}
			else {
				newLeft = Math.min(newLeft, baseLeft);
				newTop = Math.min(newTop, baseTop);
			}

			//fix for right and bottom
			if ((newLeft + imgWidth) < baseRight) {
				newLeft = baseRight - imgWidth; //newLeft - (newLeft + imgWidth - baseRight)
			}

			if ((newTop + imgHeight) < baseBottom) {
				newTop = baseBottom - imgHeight; //newTop + (newTop + imgHeight - baseBottom)
			}


			let css = {
				height: imgHeight + 'px',
				width: imgWidth + 'px',
				left: newLeft + 'px',
				top: newTop + 'px'
			};
			curImg.css(css);
			if (this.shouldCreateCanvas()) {
				this.$canvas[0].height = imgHeight;
				this.$canvas[0].width = imgWidth;
				this.$canvas.css(css);
				this.$activeCanvas.css(css);
				this.$activeCanvas[0].height = imgHeight;
				this.$activeCanvas[0].width = imgWidth;
				this.$tooltips.css(css);

				let cOff = this.$canvas.offset();
				this.canvas = {
					width: imgWidth,
					height: imgHeight,
					x: cOff.left,
					y: cOff.top
				};
			}

			this.zoomValue = tickZoom;

			this._resizeHandle(imgWidth, imgHeight, newLeft, newTop);

			//update zoom handle position
			this.zoomHandle.css('left', ((tickZoom - 100) * this._zoomSliderLength) / (maxZoom - 100) + 'px');
		}, this);

		zoom();
	},
	_clearFrames: function () {
		clearInterval(this._imageSlider.slideMomentumCheck);
		cancelAnimationFrame(this._imageSlider.sliderMomentumFrame);
		cancelAnimationFrame(this._zoomFrame)
	},
	resetZoom: function () {
		this.lastZoomPoint = null;
		this.zoom(this.options.zoomValue);
	},
	//calculate dimensions of image, container and reset the image
	_calculateDimensions: function () {
		this.setContainerDimensions();

		//calculate content width of image and snap image
		let imageWidth = this.currentImg.width(),
			imageHeight = this.currentImg.height(),
			$iv = this.$('.iv-image-view'),
			contWidth = $iv.width(),
			contHeight = $iv.height(),
			snapViewWidth = this.snapView.innerWidth(),
			snapViewHeight = this.snapView.innerHeight();

		this.containerDim = {
			w: contWidth,
			h: contHeight
		};

		//set the image dimension
		let isFlipped = this.currentImg.hasClass('transform-rotate-90') || this.currentImg.hasClass('transform-rotate-270');
		if (isFlipped) {
			let ratio = imageHeight / imageWidth,
				imgHeight = (imageWidth > imageHeight && contHeight >= contWidth) || ratio * contHeight > contWidth ? contWidth : ratio * contHeight,
				imgWidth = imgHeight / ratio;

			this.imageDim = {
				w: imgWidth - 120,
				h: imgHeight - (120 * ratio)
			};

			//set the snap Image dimension
			this.snapImg.css({
				width: this.imageDim.w > this.imageDim.h ? snapViewHeight : this.imageDim.w * snapViewHeight / this.imageDim.h,
				height: this.imageDim.h > this.imageDim.w ? snapViewWidth : this.imageDim.h * snapViewWidth / this.imageDim.w
			});
		}
		else {
			let ratio = imageWidth / imageHeight,
				imgWidth = (imageWidth > imageHeight && contHeight >= contWidth) || ratio * contHeight > contWidth ? contWidth : ratio * contHeight,
				imgHeight = imgWidth / ratio;

			this.imageDim = {
				h: imgHeight - 120,
				w: imgWidth - (120 * ratio)
			};

			//set the snap Image dimension
			this.snapImg.css({
				width: this.imageDim.w > this.imageDim.h ? snapViewWidth : this.imageDim.w * snapViewHeight / this.imageDim.h,
				height: this.imageDim.h > this.imageDim.w ? snapViewHeight : this.imageDim.h * snapViewWidth / this.imageDim.w
			});
		}

		this.imgWidth = this.imageDim.w * this.zoomValue / 100;
		this.imgHeight = this.imageDim.h * this.zoomValue / 100;

		//reset image position and zoom
		let newLeft = (contWidth - this.imageDim.w) / 2,
			newTop = (contHeight - this.imageDim.h) / 2,
			css = {
				width: this.imageDim.w + 'px',
				height: this.imageDim.h + 'px',
				left: newLeft + 'px',
				top: newTop + 'px',
				'max-width': 'none',
				'max-height': 'none'
			};
		this.currentImg.css(css);

		if (this.shouldCreateCanvas()) {
			this.$canvas.css(css);
			this.$activeCanvas.css(css);
			this.$tooltips.css(css);

			let cOff = this.$canvas.offset();
			this.canvas = {
				width: this.imageDim.w,
				height: this.imageDim.h,
				x: cOff.left,
				y: cOff.top
			};
		}

		//calculate zoom slider area
		this._zoomSliderLength = snapViewWidth - this.zoomHandle.outerWidth();
	},
	refresh: function (refreshOpts) {
		if (!this.loaded) {
			return;
		}
		this._calculateDimensions();
		this.resetZoom();
	},
	_resizeHandle: function (imgWidth, imgHeight, imgLeft, imgTop) {
		this.imgWidth = imgWidth || this.imageDim.w * this.zoomValue / 100;
		this.imgHeight = imgHeight || this.imageDim.h * this.zoomValue / 100;

		let left = Math.max(-(imgLeft || parseFloat(this.currentImg.css('left'))) * 100 / this.imgWidth, 0),
			top = Math.max(-(imgTop || parseFloat(this.currentImg.css('top'))) * 100 / this.imgHeight, 0),
			handleWidth = Math.min(this.containerDim.w * 100 / this.imgWidth, 100),
			handleHeight = Math.min(this.containerDim.h * 100 / this.imgWidth, 100);

		this.snapHandle.css({
			top: top + '%',
			left: left + '%',
			width: handleWidth + '%',
			height: handleHeight + '%'
		});

		if (this.loaded) {
			this.afterDimensionChange();
		}
	},
	afterDimensionChange: function () {

	},
	show: function (image, showOpts) {
		this.$el.show();
		if (image) {
			this.load(image, showOpts);
		}
	},
	options: function (key, value) {
		if (!value) {
			return this.options[key];
		}
		this.options[key] = value;
	},
	destroy: function () {
		if (this.options.route) {
			PJQ.app.router.navigate(this.options.previousRoute, {
				trigger: this.options.triggerRoute
			});
			this.options.triggerRoute = false;
			this.options.route = null;
		}

		$(window).off('.' + this._viewerId);
		$(document).off('.' + this._viewerId);
		this.$el.off();
		this.$el.remove();
		this.onClose();

		$('body').css('overflow', 'auto');
	},
	onClose: function(){
		if (typeof this.options.onClose === 'function') {
			this.options.onClose();
		}
	},
	delete: function () {
		this.model.destroy();
		this.collection.remove(this.model);
		this.options.onDelete(this.model);
		this.destroy()
	},
	download: function () {
		this.model.download();
	},
	load: function (image, loadOpts = {persistZoom: false}) {
		//Clear any images that are already in the view/snap
		this.$('.iv-snap-image,.iv-large-image').remove();

		this.loader = new PJQ.Loader(this.imageView);

		//Add the snap image
		this.snapImg = $('<img>', {
			class: 'iv-snap-image',
			src: image,
			style: 'display:none;'
		});
		this.$('.iv-snap-image-wrap').prepend(this.snapImg);

		this.imageWrap.empty();

		//Add the full image
		this.imageWrap.prepend($('<img>', {
			class: 'iv-large-image noselect',
			src: image,
			style: 'display:none;'
		}));

		if (this.shouldCreateCanvas()) {
			this.imageWrap.prepend($('<div>', {
				class: 'iv-tooltips-outer noselect'
			}));

			this.imageWrap.prepend($('<canvas>', {
				class: 'iv-canvas noselect'
			}));

			this.imageWrap.append($('<canvas>', {
				class: 'iv-active-canvas noselect'
			}));

			this.$canvas = this.$('.iv-canvas');
			this.ctx = this.$canvas[0].getContext('2d');

			this.$activeCanvas = this.$('.iv-active-canvas');
			this.activeCtx = this.$activeCanvas[0].getContext('2d');

			this.$tooltips = this.$('.iv-tooltips-outer');
		}

		this.currentImg = this.$('.iv-large-image');

		this.loaded = false;

		if(this.model && this.model.get('createdOn')) {
			this.createdOnDate.attr('hidden', false);
			this.createdOnDate.html(PJQ.helpers.dateHelpers.getDateString(this.model.get('createdOn'), PJQ.helpers.dateHelpers.dateFormats.DATE));
		}
		else{
			this.createdOnDate.attr('hidden', true);
		}

		//refresh the view
		let refreshView = _.bind(function () {
			this.afterImageDownload();

			let fnRender = _.bind(function () {
				this.loader.remove();
				this.loaded = true;

				let newZoom = this.zoomValue,
					newZoomPoint = this.lastZoomPoint;
				this.zoomValue = 100;
				this.refresh(loadOpts);
				if (loadOpts.persistZoom && this.prevItemInfo) {
					this.zoom(newZoom, newZoomPoint);
				}
				else {
					this.resetZoom();
				}

				this.afterLoad();

				this.currentImg.show();
				this.snapImg.show();
			}, this);
			let chromeVer = PJQ.helpers.browserHelpers.getChromeVersion();
			if (this.model.get('rotation') != null && !(this.model instanceof PJQ.models.drawings.Drawing)) {
				PJQ.helpers.imageHelpers.rotateElement(this.currentImg.add(this.snapImg), this.model.get('rotation'));
				fnRender();
			}
			else if (chromeVer == null || chromeVer >= 81) {
				fnRender();
			}
			else {
				PJQ.helpers.imageHelpers.rotateByExif(this.currentImg.add(this.snapImg), _.bind(function () {
					fnRender();
				}, this));
			}
		}, this);

		let currentImage = this.currentImg[0];
		if (currentImage.complete && (typeof currentImage.naturalWidth === 'undefined' || currentImage.naturalWidth !== 0)) {
			refreshView();
		}
		else {
			$(currentImage).on('load', refreshView);
		}
	},
	afterImageDownload: function () {

	},
	afterLoad: function(){}
});

PJQ.views.files.FileViewer = PJQ.views.photos.PhotoViewer.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Viewer'),
		zoomValue: 100,
		snapView: true,
		maxZoom: 500,
		refreshOnResize: true,
		zoomOnMouseWheel: true,
		triggerRoute: false,
		isDisableDownload: true
	},
	events: {
		'click .iv-prev': 'previous',
		'click .iv-next': 'next',
		'contextmenu .iv-image-view': 'preventRightClick'
	},
	initPaging: function () {
		this.pageCount = this.model.get('pages');
		if (!(this.pageCount > 0)) {
			this.pageCount = 1;
		}
		this.pageIndex = 0;

		this.renderPaging();
	},
	renderPaging: function () {
		if (this.pageCount > 1) {
			this.$('.iv-paging').removeClass('hidden');
			this.pagingDisplay = this.$('.iv-paging-display');

			this.pagingDisplay.html((this.pageIndex + 1).toString() + ' of ' + this.pageCount.toString());
			if (this.pageIndex === 0) {
				this.prevButton.addClass('disabled');
			}
			else {
				this.prevButton.removeClass('disabled');
			}

			if ((this.pageIndex + 1) === this.pageCount) {
				this.nextButton.addClass('disabled');
			}
			else {
				this.nextButton.removeClass('disabled');
			}
		}
		else {
			this.$('.iv-paging').addClass('hidden');
		}
	},
	renderPage: function () {
		if (this.$('.iv-image-view').length > 0) {
			this.show(this.model.renderUrl(this.pageIndex + 1));
		}
	},
	previous: function () {
		if (this.pageIndex > 0) {
			--this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	next: function () {
		if ((this.pageIndex + 1) < this.pageCount) {
			++this.pageIndex;
			this.renderPaging();
			this.renderPage();
		}
	},
	afterImageDownload: function () {
		if (!(this.model.get('pages') > 0)) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'files',
						value: this.model.get('entryId')
					},
					{
						endpoint: 'pages'
					}])
			}).get().done(_.bind(function (response) {
				this.model.set('pages', response.pages);
				this.initPaging();
			}, this));
		}
		else {
			this.renderPaging();
		}
	},
	preventRightClick: function () {
		return false;
	}
});

PJQ.views.photos.Slider = class {
	constructor($el, options) {
		this.container = $el;
		this.onStart = options.onStart || _.noop;
		this.onMove = options.onMove || _.noop;
		this.onEnd = options.onEnd || _.noop;
		this.sliderId = options.sliderId || 'slider' + Math.ceil(Math.random() * 1000000);
		this.viewer = options.viewer ? options.viewer : null;
	}

	init() {
		let self = this,
			eventSuffix = '.' + this.sliderId,
			$document = $(document);

		//assign event on snap image wrap
		this.container.on('touchstart' + eventSuffix + ' mousedown' + eventSuffix, function (eStart) {
			let def = function (eStart) {
				eStart.preventDefault();
				let touchMove = (eStart.type === "touchstart" ? "touchmove" : "mousemove") + eventSuffix,
					touchEnd = (eStart.type === "touchstart" ? "touchend" : "mouseup") + eventSuffix,
					eOriginal = eStart.originalEvent,
					sx = eOriginal.clientX || eOriginal.touches[0].clientX,
					sy = eOriginal.clientY || eOriginal.touches[0].clientY,
					start = self.onStart(eStart, {
						x: sx,
						y: sy
					});
				if (start === false)
					return;

				let moveListener = function (eMove) {
						eMove.preventDefault();

						eOriginal = eMove.originalEvent;

						//get the coordinates
						let mx = eOriginal.clientX || eOriginal.touches[0].clientX,
							my = eOriginal.clientY || eOriginal.touches[0].clientY;

						self.onMove(eMove, {
							dx: mx - sx,
							dy: my - sy,
							mx: mx,
							my: my
						});

					},
					endListener = function () {
						$document.off(touchMove, moveListener);
						$document.off(touchEnd, endListener);
						self.onEnd();
					};

				$document.on(touchMove, moveListener);
				$document.on(touchEnd, endListener);
			}
			if (self.viewer && typeof self.viewer.onMouseDown === 'function' && (false === self.viewer.canDrag() || false === self.viewer.onMouseDown(eStart, def))) {
				return;
			}
			def(eStart);
		});

		return this;
	}
};